import { render } from "./my-profile.vue?vue&type=template&id=1f18ae04"
import script from "./my-profile.vue?vue&type=script&lang=js"
export * from "./my-profile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\SphinxProjects\\VUE3\\Excel_Library_Frontend_Website\\excel-library-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__